import { FiltersType } from '../../types/filters';
import { FeedType } from '../../types/feed';
import { QueryObjectType } from '../../utils/parseQuery';

export const mapUrlParams = (filters: QueryObjectType): FeedType => ({
	currency: filters.currency,
	limit: filters.limit,
	googleFeedUrl: filters.googleFeedUrl,
	fbFeedUrl: filters.fbFeedUrl,
	locale: filters.locale,
	utm_campaign: filters.utm_campaign,
	utm_content: filters.utm_content,
	utm_medium: filters.utm_medium,
	utm_source: filters.utm_source,
});

export const mapFilters = (filters: QueryObjectType): FiltersType => ({
	'active-warranty': filters['active-warranty'],
	'air-conditioning-feature': filters['air-conditioning-feature'],
	'auxiliary-heating-feature': filters['auxiliary-heating-feature'],
	'car-style': filters['car-style'],
	color: filters.color,
	condition: filters.condition,
	'cruise-control-feature': filters['cruise-control-feature'],
	'cubic-capacity-from': filters['cubic-capacity-from'],
	'cubic-capacity-to': filters['cubic-capacity-to'],
	'display-feature': filters['display-feature'],
	'door-count': filters['door-count'],
	drive: filters.drive,
	'emission-class': filters['emission-class'],
	feature: filters.feature,
	'fuel-consumption-combined-to': filters['fuel-consumption-combined-to'],
	'fuel-type': filters['fuel-type'],
	'headlights-type-feature': filters['headlights-type-feature'],
	'interior-color': filters['interior-color'],
	'interior-material': filters['interior-material'],
	make: filters.make,
	'mileage-from': filters['mileage-from'],
	'mileage-to': filters['mileage-to'],
	model: [...(filters['model'] || [])] as string[] | number[],
	'model-group': filters['model-group'],
	'number-of-airbags-from': filters['number-of-airbags-from'],
	'number-of-gears': filters['number-of-gears'],
	'number-of-owners-to': filters['number-of-owners-to'],
	'number-of-seats-from': filters['number-of-seats-from'],
	'origin-country': filters['origin-country'],
	country: filters.country,
	'parking-camera-feature': filters['parking-camera-feature'],
	'parking-sensors-feature': filters['parking-sensors-feature'],
	'power-from': filters['power-from'],
	'power-to': filters['power-to'],
	'price-from': filters['price-from'],
	'price-to': filters['price-to'],
	'registration-date-from': filters['registration-date-from'],
	'registration-date-to': filters['registration-date-to'],
	seller: filters.seller,
	'sliding-doors-feature': filters['sliding-doors-feature'],
	source: filters.source,
	status: filters.status,
	'sunroof-feature': filters['sunroof-feature'],
	'tailgate-opening-feature': filters['tailgate-opening-feature'],
	'trailer-coupling-feature': filters['trailer-coupling-feature'],
	transmission: filters.transmission,
	'vat-reclaimable': filters['vat-reclaimable'],
	search: filters.search,
	page: filters.page,
	hidden: filters.hidden,
	'advertising-rules-apply': filters['advertising-rules-apply'],
	'advertising-rules-user-country': filters['advertising-rules-user-country'],
	'advertising-rules-user-dealer': filters['advertising-rules-user-dealer'],
	'available-in-feed': filters['available-in-feed'],
	'available-in-feed-computed': filters['available-in-feed-computed'],
	'advertised-car-id': filters['advertised-car-id'],
	'installment-from': filters['installment-from'],
	'installment-to': filters['installment-to'],
	'country-score-from': filters['country-score-from'],
	'country-score-to': filters['country-score-to'],
	'market-score-to': filters['market-score-to'],
	'market-score-from': filters['market-score-from'],
	'market-score-interval': filters['market-score-interval'],
	'model-percentage': filters['model-percentage'],
	'registration-month-from': filters['registration-month-from'],
	'registration-month-to': filters['registration-month-to'],
	'with-discount': filters['with-discount'],
	'vehicle-tags': filters['vehicle-tags'],
	'dealer': filters['dealer'],
});
